module.exports = __webpack_public_path__ + "img/edge_hebergements_hebergement_insolite_2.07932b4a.svg";